import React from "react";
import "./cards.css";
import Coin from "../../../../assets/svg/Coin";
import BigArrow from "../../../../assets/svg/BigArrow";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ProgressBarNew from "../../theme6/component/ProgressBarNew";

const Cards = ({ data = {}, wallet }) => {
  const navigate = useNavigate()
  const getAppSelector = useSelector(state => state.getApp)
  const { Config } = getAppSelector
  return (
    <>
      <div className="card-border">


        <div className="card-container" onClick={() => navigate(`/cardDetails/${data?._id}`)}>
          <div className="card-section">
            <div className="card-img" style={{ background: data?.outer_color }}>
              <img src={data?.image?.mobile} alt={data?.name} />
            </div>

            <div className="card-info">
              <div className="card-head">{data?.name}</div>
              <div className="card-desc">{`${wallet?.redemption >= data?.price?.denominations[0] * Config?.rup_val ? "Redeem your Gift Card Now" : `${data?.price?.denominations[0] * Config?.rup_val - wallet?.redemption} Coins left to redeem gift card`}`}</div>
          

                <ProgressBarNew
                  current={wallet?.redemption || 0}
                  total={data?.price?.denominations[0] * Config?.rup_val}
                  height="16px"
                  backgroundColor="#372e5c"
                  progressColor="#fff8f8"
                  textColor="#fff8f8"
                  progressTextColor="#372e5c"
                  borderRadius="18.57px"
                  textSize="8px"
                />

              <div className="coin-info">
                <div className="coin-img">
                  <Coin width={20} height={20} />
                  <p className="coinValue">{data?.price?.denominations[0] * Config?.rup_val|| 100}</p>
                </div>
                <p>Coins required</p>
              </div>
            </div>
          </div>
          <div className="card-button">
            <p className="see-all">{wallet?.redemption >= data?.price?.denominations[0] * Config?.rup_val  ? "Redeem Now" : "See Details"}</p>
            <BigArrow />
          </div>
        </div>
      </div>
    </>
  );
};

export default Cards;
